import { useParams } from 'react-router-dom'

import { useWidgetGetApi } from '@/common/api/modules/widget'
import { useSiteId } from '@/common/app/site'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import WidgetEditPage from '@/components/container/page/site/recommend/widget/WidgetEditPage'

const WidgetUpdatePage = () => {
  const siteId = useSiteId()
  const { widgetId } = useParams()

  const { data, error, mutate } = useWidgetGetApi({
    siteId,
    widgetId: Number(widgetId)
  })

  return (
    <DetailPageLoader error={error} data={data}>
      <WidgetEditPage widget={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default WidgetUpdatePage
